export function getCurrentTimestamp() {
  const currentDate = new Date();
  const currentTimestamp = currentDate.getTime();

  return currentTimestamp;
}
